// The new, streamlined interface (10 October 2026): Polis, the Projections
// tab. "Close" and "Loading…" are still read from `projector.commun`.
export default {
  erreurLecture: 'Could not read the projection',
  erreurLancement: 'The wave could not be started',
  // The election's Sonar (11 October 2026): a discreet link per list or candidate.
  interroger: 'Talk to their voters',
  vague: {
    libelle: 'Wave',
    option: '{jour} · {libelle}',
    optionHeure: '{base}, {heure}',
    enCours: '{vague} · in progress',
  },
  lancer: {
    bouton: 'Run a wave',
    question: 'Run a wave now?',
    // The last update of the candidacies is more than 24 hours old (21 October 2026).
    questionPoint: 'Run a wave now? Orion will first update the candidacies.',
    confirmer: 'Run',
    annuler: 'Cancel',
  },
  // Updating the candidacies before a wave (21 October 2026).
  point: {
    enCours: 'Orion is updating the candidacies…',
    echec: 'Updating the candidacies did not succeed: {raison}. Run the wave anyway?',
    quandMeme: 'Run anyway',
    tropLong: 'it did not come back within twenty minutes',
    sansRaison: 'unknown reason',
  },
  // The seal of the wave shown (21 October 2026), next to the wave selector.
  scellement: {
    scellee: 'Sealed on {jour} at {heure}',
    essai: 'Trial sealed on {jour} at {heure}',
    heure: '{h}:{m}',
    verifier: 'Verify',
    verifierAria: 'Verify this seal in the register',
  },
  vide: {
    titre: 'No completed wave for this election',
    texte: 'The projection shows here as soon as a wave is completed.',
    enCours: 'A wave is in progress: its projection will show here as soon as it is completed.',
  },
  verdict: {
    majorite: '{bloc} would reach a majority with {n} seats.',
    aucunBloc: 'No bloc reaches {majorite} seats: {premier} would hold {n}{suite}.',
    listeMajorite: '{liste} would reach a majority with {n} seats.',
    aucuneListe: 'No list reaches {majorite} seats: {premier} would hold {n}{suite}.',
    suite: ', {nom} {n}',
    leBloc: 'the {nom} bloc',
    leBlocNomme: 'the {nom}',
    presqueSur: '{a} reaches the runoff in almost every scenario.',
    gagne: '{a} wins in {pa} of cases.',
    gagne2: '{a} wins in {pa} of cases, {b} in {pb}.',
    gagnePluriel: '{a} win in {pa} of cases.',
    gagne2Pluriel: '{a} win in {pa} of cases, {b} in {pb}.',
    adversaires: 'The opponent is between {b} and {c}, with a {pb}% and {pc}% chance.',
    adversaire: 'The opponent would be {b}, with a {pb}% chance.',
    ouvert3: 'The runoff is between {a} ({pa}), {b} ({pb}) and {c} ({pc}).',
    ouvert2: 'The runoff is between {a} ({pa}) and {b} ({pb}).',
    enTete: 'Leading the first round: {listes}.',
    candidat: '{nom} ({pct})',
  },
  sousVerdict: {
    sondages: 'Projection of {jour}, framed by the {n} polls published from {du} to {au}',
    unSondage: 'Projection of {jour}, framed by the only poll published from {du} to {au}',
    sansSondage: 'Projection of {jour}, with no poll published in the thirty days before it',
    loinDuVote: '{texte} · {mois} months before the vote, the ranges remain wide',
  },
  hemicycle: {
    titre: 'The projected chamber',
    aria: 'The projected chamber: {total} seats, majority at {majorite}',
    legende: 'The seats of each list',
  },
  blocs: {
    titre: 'The blocs',
    fourchette: '{bas} ~ {haut} seats',
    jumeaux: 'Twins: {n} seats',
    chanceJumeaux: '{pct} chance of reaching {majorite} according to the twins',
    sondages: 'polls {n}',
    chance: '{pct} chance of reaching {majorite}',
    loin: 'far from {majorite}',
    trait: 'The dotted line marks the {majorite} seats of the majority',
  },
  listes: {
    titre: 'The lists',
    legende: 'in seats · the bar shows the range, the line the polling average',
    legendeSansSondages: 'in seats · the bar shows the range',
    liste: 'List',
    voix: 'Votes',
    projection: 'Projection',
    fourchette: 'Range',
    sondages: 'Polls',
    ecart: 'Gap',
    aucune: 'No list wins a seat in this wave.',
  },
  seuil: {
    titre: 'Around the threshold',
    legende: 'the chance of clearing the threshold, and so of winning seats',
    legendeSansChance: 'no seat in this wave',
  },
  premierTour: {
    titre: 'The first round',
    titreUnTour: 'The vote',
    gagne: 'Chance of winning',
    legende: 'the bar shows the range, the line the polling average',
    legendeSansSondages: 'the bar shows the range',
    candidat: 'Candidate',
    fourchette: 'Range',
    projection: 'Projection',
    projectionSondages: 'Poll projection',
    qualifie: 'in the runoff',
    autres: 'See the {n} other candidates',
    replier: 'Show only the runoff',
    projectionJumeaux: 'Twins projection',
    deuxProjections: 'The poll projection says what the polls will publish; the twins projection, what the electorate they form thinks, without the polls.',
    legendeJumeaux: 'the bar shows the range of the projected polls, the line their average, the dot the twins projection',
    fourchetteJumeaux: 'twins {f}',
    voixCourt: '{n}M votes',
    second: 'In the runoff',
    sondages: 'polls {n}',
    voix: '{n}M votes',
    possible: 'possible candidacy, {p}',
    bulletin: 'declared, on the ballot at {p}',
    // The central projection (21 October 2026): the most likely scenario according to the twins, the Scenarios tab's.
    projectionCentrale: 'Central projection',
    // The declared-candidates projection (21 October 2026): only the officially declared candidates.
    projectionDeclares: 'Declared candidates projection',
    // Narrow, three or more columns of numbers: their short names. The selector uses them too.
    court: {
      sondages: 'Polls',
      jumeaux: 'Twins',
      centrale: 'Central',
      declares: 'Declared',
    },
    enumeration: '{debut} and {fin}',
    // A single projection: each candidate's rank, read out to screen readers.
    rang: 'Rank',
  },
  // The selector above the first round (21 October 2026): every projection, or a single one.
  vues: {
    aria: 'Projection shown',
    tout: 'All',
  },
  centrale: {
    sans: 'Central projection: without {noms}, who would probably not run.',
    sansUn: 'Central projection: without {noms}, who would probably not run.',
    absent: 'would probably not run',
    aMesurer: 'will be measured in the next wave',
  },
  declares: {
    sans: 'Declared candidates projection: without {noms}, whose candidacies are not declared.',
    sansUn: 'Declared candidates projection: without {noms}, whose candidacy is not declared.',
    absent: 'candidacy not declared',
  },
  // What the chosen view shows, under the first-round title (21 October 2026): never how Orion computes it.
  explication: {
    tout: 'The bar shows the range of the projected polls, the line their average, the dot the twins projection; the runoff, according to the twins. The framed column is the central projection.',
    sondages: 'What the polls would say, according to Orion. The bar shows the range, the line the average of the polls already published.',
    jumeaux: 'How Orion’s twins would vote.',
    jumeauxTous: 'How Orion’s twins would vote if every possible candidate ran.',
    centrale: 'How the twins would vote if only the likely candidates ran: the most likely scenario.',
    declares: 'How the twins would vote if only the officially declared candidates ran.',
  },
  participation: {
    ligne: 'Projected turnout: {taux} ({fourchette})',
    exprimes: '{n} million valid votes out of {inscrits} million registered voters',
    parVague: 'Wave by wave',
    masquer: 'Hide',
  },
  duels: {
    titre: 'The likely runoffs',
    legende: 'the share of scenarios in which this runoff happens',
    legendeJumeaux: 'according to the twins: the share of scenarios in which this runoff happens, and how they would vote in it, among valid votes',
    face: '{a} against {b}',
    mesure: '{a} {pa} · {b} {pb}',
    gagne: '{nom} wins in {p} of cases',
  },
  vainqueur: {
    titre: 'The likely winner',
    chance: '{p} of cases',
    autre: '{nom} {p}',
    nonMesure: 'runoffs not measured: {p}',
  },
  camps: {
    titre: 'The camps',
    aria: 'The share of each camp in the first round',
    sondages: 'polls {n}',
  },
  unites: {
    pct: '{n}%',
    fourchette: '{bas} ~ {haut}',
    fourchettePct: '{bas}% ~ {haut}%',
    moinsDeUn: '< 1',
  },
}
